import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthTokenService } from './auth-token.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionsProviderService implements CanActivate {

  userSecurityGroupProvider = {};
  permissionsIdsUserHave = [];
  permissionsIdsUserDontHave = [];
  userSecurityGroupBase = '/API/AccountServices/CheckPermissionForUser';
  logInPage = '/login';

  constructor(private http: HttpClient, private authToken: AuthTokenService, private router: Router) { }

  checkAuthorizationAvialabilityInClinet(requestedPermission) {
    var authorized = false;
    for (var i = 0; i < this.permissionsIdsUserHave.length; i++) {
      if (this.permissionsIdsUserHave[i] == requestedPermission) {
        authorized = true;
        break;
      }
    }
    return authorized;
  }

  checkNoAuthorizationAvialabilityInClinet(requestedPermission) {
    var denided = false;
    for (var i = 0; i < this.permissionsIdsUserDontHave.length; i++) {
      if (this.permissionsIdsUserDontHave[i] == requestedPermission) {
        denided = true;
        break;
      }
    }
    return denided;
  }

  checkAuthorityAndExecuteCommand(requestedPermission, authorizedCommand, notAuthorizedCommand, failedCommand) {
    var authorized = this.checkAuthorizationAvialabilityInClinet(requestedPermission);
    var denided = this.checkNoAuthorizationAvialabilityInClinet(requestedPermission);
    if (authorized) {
      if (authorizedCommand) {
        authorizedCommand();
      }
    } else if (denided) {
      if (notAuthorizedCommand) {
        notAuthorizedCommand();
      }
    }
    else {
      this.http.get(this.userSecurityGroupBase + '/' + requestedPermission).subscribe((data) => {
        if (data) {
          this.permissionsIdsUserHave.push(requestedPermission);
          if (authorizedCommand) {
            authorizedCommand();
          }
        }
        else {
          this.permissionsIdsUserDontHave.push(requestedPermission);
          if (notAuthorizedCommand) {
            notAuthorizedCommand();
          }
        }
      }, (reason) => {
        if (failedCommand) {
          failedCommand();
        }
      });
    }
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    console.log('can activate');
    if (this.authToken.isAuth()) {
      return true;
    } else {
      this.router.navigate([this.logInPage], {
        queryParams: {
          return: state.url
        }
      });
      return false;
    }
  }

  setLoginPage(value) {
    this.logInPage = value;
  }
}
